import React from 'react';
import BurnInCaptionsComponent from '../components/BurnInCaptions';
import { AddonsContextConsumer } from '../../../../context/AddonsContext';

function BurnInCaptions(props) {
  return (
    <AddonsContextConsumer>
      {({ constants: { CAPTIONS } }) =>
      <BurnInCaptionsComponent
        {...props}
        // $FlowFixMe Cannot call CAPTIONS because undefined [1] is not a function.
        BURN_IN_CAPTIONS={CAPTIONS('BURN_IN_CAPTIONS')} />}


    </AddonsContextConsumer>);

}

export default BurnInCaptions;